<template>
  <div v-if="message" :class="`message ${level}`">
    <span v-if="level === 'error'" />
    <span v-else-if="level === 'warning'" />
    <span v-else-if="level === 'info'" />
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
    level: {
      type: String,
      validator: value => ['error', 'warning', 'info'].includes(value),
      default: 'info',
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'
  .message
    display: flex
    align-items: center
    padding: 1em
    border-radius: 5px
    font-size: 1.4rem
    max-width: 500px

  .message.error
    background-color: $secondary-color
    color: red


  .message.warning
    background-color: #fff3cd
    color: #856404


  .message.info
    background-color: #cce5ff
    color: #004085

</style>
